import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ComposedChart,
  Line,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  ReferenceDot,
} from 'recharts';
import { useReportData } from './lib/report-context';

const bpdData = [
  { ga: 14, p3: 26, p10: 27, p50: 29, p90: 31, p97: 32 },
  { ga: 15, p3: 29, p10: 30, p50: 32, p90: 34, p97: 35 },
  { ga: 16, p3: 32, p10: 33, p50: 35, p90: 37, p97: 39 },
  { ga: 17, p3: 35, p10: 37, p50: 39, p90: 41, p97: 43 },
  { ga: 18, p3: 38, p10: 40, p50: 43, p90: 45, p97: 47 },
  { ga: 19, p3: 42, p10: 44, p50: 46, p90: 49, p97: 51 },
  { ga: 20, p3: 45, p10: 47, p50: 50, p90: 53, p97: 55 },
  { ga: 21, p3: 48, p10: 51, p50: 54, p90: 57, p97: 59 },
  { ga: 22, p3: 52, p10: 54, p50: 57, p90: 60, p97: 63 },
  { ga: 23, p3: 55, p10: 58, p50: 61, p90: 64, p97: 67 },
  { ga: 24, p3: 58, p10: 61, p50: 64, p90: 68, p97: 70 },
  { ga: 25, p3: 61, p10: 64, p50: 68, p90: 72, p97: 74 },
  { ga: 26, p3: 64, p10: 67, p50: 71, p90: 75, p97: 78 },
  { ga: 27, p3: 67, p10: 71, p50: 75, p90: 79, p97: 82 },
  { ga: 28, p3: 70, p10: 74, p50: 78, p90: 82, p97: 85 },
  { ga: 29, p3: 73, p10: 77, p50: 81, p90: 86, p97: 89 },
  { ga: 30, p3: 76, p10: 80, p50: 84, p90: 89, p97: 92 },
  { ga: 31, p3: 78, p10: 82, p50: 87, p90: 92, p97: 95 },
  { ga: 32, p3: 81, p10: 85, p50: 90, p90: 95, p97: 98 },
  { ga: 33, p3: 83, p10: 87, p50: 92, p90: 97, p97: 101 },
  { ga: 34, p3: 85, p10: 89, p50: 94, p90: 100, p97: 103 },
  { ga: 35, p3: 87, p10: 91, p50: 96, p90: 102, p97: 106 },
  { ga: 36, p3: 88, p10: 93, p50: 98, p90: 104, p97: 108 },
  { ga: 37, p3: 89, p10: 94, p50: 99, p90: 105, p97: 109 },
  { ga: 38, p3: 90, p10: 95, p50: 100, p90: 106, p97: 110 },
  { ga: 39, p3: 91, p10: 96, p50: 101, p90: 107, p97: 111 },
  { ga: 40, p3: 91, p10: 96, p50: 102, p90: 108, p97: 112 },
];

const hcData = [
  { ga: 14, p3: 95, p10: 99, p50: 106, p90: 113, p97: 118 },
  { ga: 15, p3: 107, p10: 112, p50: 119, p90: 127, p97: 132 },
  { ga: 16, p3: 119, p10: 124, p50: 132, p90: 140, p97: 146 },
  { ga: 17, p3: 130, p10: 136, p50: 145, p90: 154, p97: 160 },
  { ga: 18, p3: 141, p10: 148, p50: 157, p90: 167, p97: 173 },
  { ga: 19, p3: 152, p10: 159, p50: 169, p90: 179, p97: 186 },
  { ga: 20, p3: 163, p10: 171, p50: 181, p90: 192, p97: 199 },
  { ga: 21, p3: 173, p10: 182, p50: 193, p90: 204, p97: 212 },
  { ga: 22, p3: 184, p10: 193, p50: 205, p90: 217, p97: 225 },
  { ga: 23, p3: 194, p10: 203, p50: 216, p90: 228, p97: 237 },
  { ga: 24, p3: 203, p10: 213, p50: 226, p90: 239, p97: 248 },
  { ga: 25, p3: 212, p10: 223, p50: 237, p90: 250, p97: 259 },
  { ga: 26, p3: 221, p10: 232, p50: 247, p90: 261, p97: 270 },
  { ga: 27, p3: 230, p10: 242, p50: 257, p90: 272, p97: 281 },
  { ga: 28, p3: 238, p10: 251, p50: 267, p90: 282, p97: 292 },
  { ga: 29, p3: 246, p10: 259, p50: 276, p90: 292, p97: 302 },
  { ga: 30, p3: 254, p10: 268, p50: 285, p90: 302, p97: 312 },
  { ga: 31, p3: 261, p10: 276, p50: 293, p90: 311, p97: 321 },
  { ga: 32, p3: 268, p10: 284, p50: 302, p90: 319, p97: 330 },
  { ga: 33, p3: 275, p10: 291, p50: 309, p90: 328, p97: 338 },
  { ga: 34, p3: 281, p10: 297, p50: 316, p90: 335, p97: 346 },
  { ga: 35, p3: 286, p10: 303, p50: 322, p90: 342, p97: 353 },
  { ga: 36, p3: 291, p10: 308, p50: 328, p90: 348, p97: 359 },
  { ga: 37, p3: 295, p10: 313, p50: 333, p90: 353, p97: 364 },
  { ga: 38, p3: 299, p10: 317, p50: 337, p90: 358, p97: 369 },
  { ga: 39, p3: 302, p10: 320, p50: 341, p90: 362, p97: 373 },
  { ga: 40, p3: 304, p10: 323, p50: 344, p90: 365, p97: 376 },
];

const acData = [
  { ga: 14, p3: 72, p10: 77, p50: 85, p90: 93, p97: 98 },
  { ga: 15, p3: 84, p10: 89, p50: 98, p90: 107, p97: 113 },
  { ga: 16, p3: 95, p10: 101, p50: 111, p90: 121, p97: 127 },
  { ga: 17, p3: 106, p10: 113, p50: 124, p90: 135, p97: 142 },
  { ga: 18, p3: 117, p10: 124, p50: 137, p90: 149, p97: 156 },
  { ga: 19, p3: 128, p10: 136, p50: 149, p90: 163, p97: 170 },
  { ga: 20, p3: 139, p10: 148, p50: 162, p90: 176, p97: 185 },
  { ga: 21, p3: 149, p10: 159, p50: 174, p90: 189, p97: 199 },
  { ga: 22, p3: 160, p10: 170, p50: 186, p90: 202, p97: 213 },
  { ga: 23, p3: 170, p10: 181, p50: 198, p90: 215, p97: 226 },
  { ga: 24, p3: 180, p10: 192, p50: 210, p90: 228, p97: 240 },
  { ga: 25, p3: 190, p10: 203, p50: 222, p90: 241, p97: 253 },
  { ga: 26, p3: 200, p10: 213, p50: 233, p90: 253, p97: 266 },
  { ga: 27, p3: 209, p10: 223, p50: 244, p90: 265, p97: 279 },
  { ga: 28, p3: 219, p10: 233, p50: 255, p90: 277, p97: 292 },
  { ga: 29, p3: 228, p10: 244, p50: 267, p90: 290, p97: 305 },
  { ga: 30, p3: 237, p10: 254, p50: 278, p90: 302, p97: 317 },
  { ga: 31, p3: 246, p10: 263, p50: 288, p90: 313, p97: 329 },
  { ga: 32, p3: 255, p10: 273, p50: 299, p90: 325, p97: 341 },
  { ga: 33, p3: 263, p10: 282, p50: 309, p90: 336, p97: 353 },
  { ga: 34, p3: 271, p10: 291, p50: 319, p90: 347, p97: 364 },
  { ga: 35, p3: 279, p10: 300, p50: 328, p90: 357, p97: 375 },
  { ga: 36, p3: 286, p10: 308, p50: 337, p90: 367, p97: 386 },
  { ga: 37, p3: 292, p10: 315, p50: 346, p90: 376, p97: 396 },
  { ga: 38, p3: 298, p10: 322, p50: 353, p90: 384, p97: 405 },
  { ga: 39, p3: 303, p10: 328, p50: 360, p90: 392, p97: 413 },
  { ga: 40, p3: 307, p10: 332, p50: 365, p90: 398, p97: 420 },
];

const flData = [
  { ga: 14, p3: 13, p10: 14, p50: 16, p90: 18, p97: 19 },
  { ga: 15, p3: 16, p10: 17, p50: 19, p90: 21, p97: 22 },
  { ga: 16, p3: 19, p10: 20, p50: 22, p90: 24, p97: 26 },
  { ga: 17, p3: 22, p10: 23, p50: 26, p90: 28, p97: 29 },
  { ga: 18, p3: 24, p10: 26, p50: 29, p90: 31, p97: 33 },
  { ga: 19, p3: 27, p10: 29, p50: 32, p90: 35, p97: 36 },
  { ga: 20, p3: 30, p10: 32, p50: 35, p90: 38, p97: 40 },
  { ga: 21, p3: 33, p10: 35, p50: 38, p90: 41, p97: 43 },
  { ga: 22, p3: 36, p10: 38, p50: 41, p90: 44, p97: 47 },
  { ga: 23, p3: 38, p10: 40, p50: 44, p90: 47, p97: 50 },
  { ga: 24, p3: 41, p10: 43, p50: 47, p90: 51, p97: 53 },
  { ga: 25, p3: 43, p10: 46, p50: 50, p90: 54, p97: 56 },
  { ga: 26, p3: 46, p10: 48, p50: 53, p90: 57, p97: 59 },
  { ga: 27, p3: 48, p10: 51, p50: 55, p90: 60, p97: 62 },
  { ga: 28, p3: 50, p10: 53, p50: 58, p90: 62, p97: 65 },
  { ga: 29, p3: 52, p10: 56, p50: 60, p90: 65, p97: 68 },
  { ga: 30, p3: 54, p10: 58, p50: 63, p90: 67, p97: 70 },
  { ga: 31, p3: 56, p10: 60, p50: 65, p90: 70, p97: 73 },
  { ga: 32, p3: 58, p10: 62, p50: 67, p90: 72, p97: 75 },
  { ga: 33, p3: 60, p10: 64, p50: 69, p90: 74, p97: 77 },
  { ga: 34, p3: 61, p10: 65, p50: 71, p90: 76, p97: 79 },
  { ga: 35, p3: 63, p10: 67, p50: 73, p90: 78, p97: 81 },
  { ga: 36, p3: 64, p10: 68, p50: 74, p90: 80, p97: 83 },
  { ga: 37, p3: 65, p10: 70, p50: 76, p90: 81, p97: 85 },
  { ga: 38, p3: 66, p10: 71, p50: 77, p90: 83, p97: 86 },
  { ga: 39, p3: 67, p10: 72, p50: 78, p90: 84, p97: 87 },
  { ga: 40, p3: 68, p10: 73, p50: 79, p90: 85, p97: 88 },
];

const efwData = [
  { ga: 14, p3: 60, p10: 70, p50: 85, p90: 103, p97: 115 },
  { ga: 15, p3: 80, p10: 93, p50: 113, p90: 136, p97: 152 },
  { ga: 16, p3: 105, p10: 120, p50: 146, p90: 176, p97: 197 },
  { ga: 17, p3: 133, p10: 152, p50: 185, p90: 222, p97: 249 },
  { ga: 18, p3: 167, p10: 192, p50: 232, p90: 279, p97: 312 },
  { ga: 19, p3: 207, p10: 238, p50: 287, p90: 346, p97: 386 },
  { ga: 20, p3: 255, p10: 293, p50: 354, p90: 426, p97: 475 },
  { ga: 21, p3: 311, p10: 357, p50: 431, p90: 519, p97: 579 },
  { ga: 22, p3: 376, p10: 433, p50: 522, p90: 628, p97: 701 },
  { ga: 23, p3: 453, p10: 521, p50: 628, p90: 756, p97: 843 },
  { ga: 24, p3: 540, p10: 621, p50: 749, p90: 901, p97: 1005 },
  { ga: 25, p3: 640, p10: 737, p50: 888, p90: 1068, p97: 1191 },
  { ga: 26, p3: 755, p10: 868, p50: 1045, p90: 1258, p97: 1402 },
  { ga: 27, p3: 885, p10: 1019, p50: 1224, p90: 1472, p97: 1641 },
  { ga: 28, p3: 1033, p10: 1188, p50: 1428, p90: 1717, p97: 1914 },
  { ga: 29, p3: 1200, p10: 1379, p50: 1655, p90: 1990, p97: 2218 },
  { ga: 30, p3: 1385, p10: 1592, p50: 1912, p90: 2299, p97: 2563 },
  { ga: 31, p3: 1588, p10: 1828, p50: 2196, p90: 2640, p97: 2944 },
  { ga: 32, p3: 1810, p10: 2083, p50: 2502, p90: 3009, p97: 3355 },
  { ga: 33, p3: 2046, p10: 2356, p50: 2830, p90: 3402, p97: 3796 },
  { ga: 34, p3: 2289, p10: 2638, p50: 3170, p90: 3812, p97: 4255 },
  { ga: 35, p3: 2529, p10: 2918, p50: 3510, p90: 4224, p97: 4715 },
  { ga: 36, p3: 2754, p10: 3178, p50: 3824, p90: 4600, p97: 5137 },
  { ga: 37, p3: 2952, p10: 3409, p50: 4103, p90: 4939, p97: 5519 },
  { ga: 38, p3: 3115, p10: 3602, p50: 4340, p90: 5225, p97: 5841 },
  { ga: 39, p3: 3235, p10: 3750, p50: 4520, p90: 5443, p97: 6085 },
  { ga: 40, p3: 3310, p10: 3847, p50: 4640, p90: 5592, p97: 6253 },
];

const afiData = [
  { ga: 14, p3: 4, p10: 5, p50: 7, p90: 10, p97: 12 },
  { ga: 15, p3: 5, p10: 6, p50: 8, p90: 11, p97: 13 },
  { ga: 16, p3: 6, p10: 7, p50: 9, p90: 12, p97: 14 },
  { ga: 17, p3: 7, p10: 8, p50: 10, p90: 13, p97: 15 },
  { ga: 18, p3: 7, p10: 9, p50: 11, p90: 14, p97: 17 },
  { ga: 19, p3: 8, p10: 9, p50: 12, p90: 16, p97: 18 },
  { ga: 20, p3: 8, p10: 10, p50: 13, p90: 17, p97: 20 },
  { ga: 21, p3: 8, p10: 10, p50: 14, p90: 18, p97: 22 },
  { ga: 22, p3: 9, p10: 11, p50: 14, p90: 19, p97: 23 },
  { ga: 23, p3: 9, p10: 11, p50: 15, p90: 20, p97: 24 },
  { ga: 24, p3: 9, p10: 12, p50: 15, p90: 21, p97: 25 },
  { ga: 25, p3: 9, p10: 12, p50: 16, p90: 21, p97: 25 },
  { ga: 26, p3: 9, p10: 12, p50: 16, p90: 22, p97: 26 },
  { ga: 27, p3: 9, p10: 12, p50: 16, p90: 22, p97: 26 },
  { ga: 28, p3: 9, p10: 12, p50: 16, p90: 22, p97: 26 },
  { ga: 29, p3: 9, p10: 12, p50: 16, p90: 22, p97: 26 },
  { ga: 30, p3: 9, p10: 12, p50: 16, p90: 21, p97: 25 },
  { ga: 31, p3: 8, p10: 11, p50: 15, p90: 21, p97: 25 },
  { ga: 32, p3: 8, p10: 11, p50: 15, p90: 20, p97: 24 },
  { ga: 33, p3: 8, p10: 11, p50: 14, p90: 19, p97: 23 },
  { ga: 34, p3: 7, p10: 10, p50: 14, p90: 18, p97: 22 },
  { ga: 35, p3: 7, p10: 10, p50: 13, p90: 17, p97: 21 },
  { ga: 36, p3: 6, p10: 9, p50: 12, p90: 16, p97: 20 },
  { ga: 37, p3: 6, p10: 8, p50: 11, p90: 15, p97: 18 },
  { ga: 38, p3: 5, p10: 7, p50: 10, p90: 14, p97: 17 },
  { ga: 39, p3: 5, p10: 7, p50: 9, p90: 13, p97: 16 },
  { ga: 40, p3: 4, p10: 6, p50: 8, p90: 12, p97: 14 },
];

type PercentileRow = {
  ga: number;
  p3: number;
  p10: number;
  p50: number;
  p90: number;
  p97: number;
};

const CHARTS: {
  id: string;
  titleKey: string;
  abbr: string;
  unit: string;
  color: string;
  data: PercentileRow[];
  descKey: string;
}[] = [
  {
    id: 'bpd',
    titleKey: 'charts.biparietalDiameter',
    abbr: 'BPD',
    unit: 'mm',
    color: '#06b6d4',
    data: bpdData,
    descKey: 'charts.bpdDesc',
  },
  {
    id: 'hc',
    titleKey: 'charts.headCircumference',
    abbr: 'HC',
    unit: 'mm',
    color: '#8b5cf6',
    data: hcData,
    descKey: 'charts.hcDesc',
  },
  {
    id: 'ac',
    titleKey: 'charts.abdominalCircumference',
    abbr: 'AC',
    unit: 'mm',
    color: '#f59e0b',
    data: acData,
    descKey: 'charts.acDesc',
  },
  {
    id: 'fl',
    titleKey: 'charts.femurLength',
    abbr: 'FL',
    unit: 'mm',
    color: '#10b981',
    data: flData,
    descKey: 'charts.flDesc',
  },
  {
    id: 'efw',
    titleKey: 'charts.estimatedFetalWeight',
    abbr: 'EFW',
    unit: 'g',
    color: '#ef4444',
    data: efwData,
    descKey: 'charts.efwDesc',
  },
  {
    id: 'afi',
    titleKey: 'charts.amnioticFluidIndex',
    abbr: 'AFI',
    unit: 'cm',
    color: '#0ea5e9',
    data: afiData,
    descKey: 'charts.afiDesc',
  },
];

// ─── Percentile helpers ────────────────────────────────────────────────────────

function computePercentile(
  data: PercentileRow[],
  ga: number,
  value: number
): { label: string; color: string } {
  const row = data.find((d) => d.ga === Math.round(ga));
  if (!row) return { label: '—', color: '#94a3b8' };
  if (value < row.p3) return { label: '< P3', color: '#ef4444' };
  if (value < row.p10) return { label: 'P3–P10', color: '#f59e0b' };
  if (value < row.p50) return { label: 'P10–P50', color: '#10b981' };
  if (value < row.p90) return { label: 'P50–P90', color: '#10b981' };
  if (value < row.p97) return { label: 'P90–P97', color: '#f59e0b' };
  return { label: '> P97', color: '#ef4444' };
}

// ─── Tooltip ───────────────────────────────────────────────────────────────────

const CustomTooltip = ({
  active,
  payload,
  label,
  unit,
  color,
  measuredValue,
  t,
}: {
  active?: boolean;
  payload?: { dataKey: string; value: number }[];
  label?: number;
  unit?: string;
  color?: string;
  measuredValue?: number | null;
  t: (key: string, opts?: Record<string, unknown>) => string;
}) => {
  if (!active || !payload?.length) return null;
  const row = (key: string, pctLabel: string) => {
    const d = payload.find((x) => x.dataKey === key);
    if (!d) return null;
    return (
      <div key={key} className="flex justify-between gap-4 mb-0.5">
        <span className="text-[11px] text-slate-400">{pctLabel}</span>
        <span className="text-[11px] font-semibold text-slate-700 dark:text-slate-200">
          {d.value} {unit}
        </span>
      </div>
    );
  };
  return (
    <div className="bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-700 rounded-lg shadow-lg px-3 py-2.5 min-w-[160px]">
      <div
        className="text-xs font-bold mb-2 pb-1.5 border-b border-slate-100 dark:border-gray-700"
        style={{ color }}
      >
        {t('charts.gaLabel', { ga: label })}
      </div>
      {row('p97', '97th')}
      {row('p90', '90th')}
      {row('p50', '50th ●')}
      {row('p10', '10th')}
      {row('p3', '3rd')}
      {measuredValue != null && (
        <div className="mt-1.5 pt-1.5 border-t border-slate-100 dark:border-gray-700 flex justify-between gap-4">
          <span className="text-[11px] font-bold text-indigo-600 dark:text-indigo-400">
            {t('charts.measured')}
          </span>
          <span className="text-[11px] font-bold text-indigo-600 dark:text-indigo-400">
            {measuredValue} {unit}
          </span>
        </div>
      )}
    </div>
  );
};


const GrowthChart = ({
  chart,
  currentGA,
  measuredValue,
}: {
  chart: (typeof CHARTS)[0];
  currentGA: number | null;
  measuredValue?: number | null;
}) => {
  const { t } = useTranslation('Report');
  const { titleKey, abbr, unit, color, data, descKey } = chart;
  const title = t(titleKey);
  const desc = t(descKey);

  const pctile =
    currentGA != null && measuredValue != null
      ? computePercentile(data, currentGA, measuredValue)
      : null;

  return (
    <div className="bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-700 rounded-xl p-4 relative overflow-hidden">
      {/* subtle accent glow */}
      <div
        className="absolute top-0 right-0 w-28 h-28 rounded-full pointer-events-none opacity-20 blur-2xl"
        style={{ background: color }}
      />

      {/* Card header */}
      <div className="mb-3">
        <div className="flex items-center gap-2 flex-wrap">
          <span
            className="text-[10px] font-bold px-2 py-0.5 rounded-full border tracking-wide"
            style={{
              color,
              background: `${color}18`,
              borderColor: `${color}44`,
            }}
          >
            {abbr}
          </span>
          <span className="text-sm font-semibold text-slate-700 dark:text-gray-100">
            {title}
          </span>
          <span className="text-[10px] text-slate-400 dark:text-gray-500">
            ({unit})
          </span>

          {/* Measured value + percentile badge */}
          {measuredValue != null && (
            <div className="ml-auto flex items-center gap-1.5">
              <span className="text-[11px] font-bold text-indigo-600 dark:text-indigo-400">
                {measuredValue} {unit}
              </span>
              {pctile && (
                <span
                  className="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                  style={{
                    color: pctile.color,
                    background: `${pctile.color}18`,
                    border: `1px solid ${pctile.color}44`,
                  }}
                >
                  {pctile.label}
                </span>
              )}
            </div>
          )}
        </div>
        <p className="text-[11px] text-slate-400 dark:text-gray-500 mt-1 leading-relaxed">
          {desc}
        </p>
      </div>

      {/* Chart */}
      <ResponsiveContainer width="100%" height={250}>
        <ComposedChart
          data={data}
          margin={{ top: 8, right: 6, left: -10, bottom: 0 }}
        >
          <defs>
            <linearGradient id={`zone-${abbr}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={color} stopOpacity={0.12} />
              <stop offset="95%" stopColor={color} stopOpacity={0.02} />
            </linearGradient>
          </defs>

          <CartesianGrid
            strokeDasharray="3 3"
            stroke="#e2e8f0"
            className="dark:stroke-gray-700"
          />

          <XAxis
            dataKey="ga"
            type="number"
            domain={[14, 40]}
            ticks={[14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40]}
            tick={{ fill: '#94a3b8', fontSize: 9 }}
            tickLine={false}
            axisLine={{ stroke: '#e2e8f0' }}
            label={{
              value: t('charts.gaWeeks'),
              position: 'insideBottom',
              offset: -2,
              fill: '#94a3b8',
              fontSize: 9,
            }}
          />
          <YAxis
            tick={{ fill: '#94a3b8', fontSize: 9 }}
            tickLine={false}
            axisLine={false}
            width={40}
            tickFormatter={(v) =>
              abbr === 'EFW' && v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v
            }
          />

          <Tooltip
            content={
              <CustomTooltip
                unit={unit}
                color={color}
                measuredValue={currentGA != null ? measuredValue : null}
                t={t}
              />
            }
          />

          {/* shaded p10–p90 zone */}
          <Area
            dataKey="p90"
            stroke="none"
            fill={`url(#zone-${abbr})`}
            legendType="none"
          />

          {/* percentile lines */}
          <Line
            dataKey="p3"
            stroke="#cbd5e1"
            strokeWidth={1}
            strokeDasharray="4 4"
            dot={false}
            legendType="none"
          />
          <Line
            dataKey="p10"
            stroke="#94a3b8"
            strokeWidth={1}
            strokeDasharray="2 2"
            dot={false}
            legendType="none"
          />
          <Line
            dataKey="p50"
            stroke={color}
            strokeWidth={2.5}
            dot={false}
            legendType="none"
          />
          <Line
            dataKey="p90"
            stroke="#94a3b8"
            strokeWidth={1}
            strokeDasharray="2 2"
            dot={false}
            legendType="none"
          />
          <Line
            dataKey="p97"
            stroke="#cbd5e1"
            strokeWidth={1}
            strokeDasharray="4 4"
            dot={false}
            legendType="none"
          />

          {/* GA reference line */}
          {currentGA && (
            <ReferenceLine
              x={currentGA}
              stroke={color}
              strokeDasharray="6 3"
              strokeWidth={1.5}
              label={{
                value: `${currentGA}w`,
                position: 'top',
                fill: color,
                fontSize: 10,
              }}
            />
          )}

          {/* ── Measured biometry point ── */}
          {currentGA != null && measuredValue != null && (
            <ReferenceDot
              x={currentGA}
              y={measuredValue}
              r={6}
              fill="#6366f1"
              stroke="#fff"
              strokeWidth={2}
              label={{
                value: `${measuredValue}`,
                position: 'top',
                fill: '#6366f1',
                fontSize: 10,
                fontWeight: 700,
              }}
            />
          )}
        </ComposedChart>
      </ResponsiveContainer>

      {/* Percentile legend */}
      <div className="flex flex-wrap gap-3 mt-2">
        {[
          { key: 'p97', label: '97th', dash: true, muted: true },
          { key: 'p90', label: '90th', dash: false, muted: true },
          { key: 'p50', label: '50th', dash: false, muted: false },
          { key: 'p10', label: '10th', dash: false, muted: true },
          { key: 'p3', label: '3rd', dash: true, muted: true },
        ].map(({ key, label, dash, muted }) => (
          <div key={key} className="flex items-center gap-1">
            <div
              className="w-4 h-0"
              style={{
                borderTop: `2px ${dash ? 'dashed' : 'solid'} ${muted ? '#94a3b8' : color}`,
                opacity: muted ? 0.6 : 1,
              }}
            />
            <span className="text-[10px] text-slate-400 dark:text-gray-500">
              {label}
            </span>
          </div>
        ))}
        {/* Measurement dot legend entry */}
        {measuredValue != null && (
          <div className="flex items-center gap-1">
            <div
              className="w-3 h-3 rounded-full border-2 border-white"
              style={{ background: '#6366f1', boxShadow: '0 0 0 1px #6366f1' }}
            />
            <span className="text-[10px] text-indigo-500 dark:text-indigo-400 font-semibold">
              {t('charts.measured')}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};


function useContextGA(): number | null {
  const { pregnancyInfo, studyInfo } = useReportData();

  const refDate =
    studyInfo?.studyDate && studyInfo.studyDate !== 'Unknown'
      ? new Date(studyInfo.studyDate)
      : new Date();
  const refTime = isNaN(refDate.getTime()) ? Date.now() : refDate.getTime();

  let lmpTime: number | null = null;
  const lmpStr = pregnancyInfo?.lastMenstrualPeriod;
  if (lmpStr && lmpStr !== 'Unknown') {
    const lmp = new Date(lmpStr);
    if (!isNaN(lmp.getTime())) lmpTime = lmp.getTime();
  }
  if (lmpTime === null) {
    const eddStr = pregnancyInfo?.estimatedDueDate;
    if (eddStr && eddStr !== 'Unknown') {
      const edd = new Date(eddStr);
      if (!isNaN(edd.getTime()))
        lmpTime = edd.getTime() - 280 * 24 * 60 * 60 * 1000;
    }
  }
  if (lmpTime === null) return null;
  const weeks = Math.floor((refTime - lmpTime) / (7 * 24 * 60 * 60 * 1000));
  return weeks >= 14 && weeks <= 40 ? weeks : null;
}


export default function FetalGrowthCharts() {
  const { t } = useTranslation('Report');
  const contextGA = useContextGA();
  const { biometryValues, efw } = useReportData();
  const [manualGA, setManualGA] = useState('');
  const [layout, setLayout] = useState<'grid' | 'single'>('grid');
  const [activeChart, setActiveChart] = useState('bpd');

  const currentGA = manualGA
    ? parseInt(manualGA) >= 14 && parseInt(manualGA) <= 40
      ? parseInt(manualGA)
      : null
    : contextGA;

  const measurementValues: Record<string, number | undefined> = {
    bpd:
      biometryValues?.bpd != null
        ? Math.round(biometryValues.bpd * 10)
        : undefined,
    hc:
      biometryValues?.hc != null
        ? Math.round(biometryValues.hc * 10)
        : undefined,
    ac:
      biometryValues?.ac != null
        ? Math.round(biometryValues.ac * 10)
        : undefined,
    fl:
      biometryValues?.fl != null
        ? Math.round(biometryValues.fl * 10)
        : undefined,
    efw: efw?.efwGrams != null ? Math.round(efw.efwGrams) : undefined,
    afi: undefined,
  };

  return (
    <div className="p-4 space-y-4">
      {/* Controls bar */}
      <div className="flex items-center gap-3 flex-wrap">
        {/* GA input */}
        <div className="flex items-center gap-2 px-3 py-1.5 bg-slate-50 dark:bg-gray-800/60 border border-slate-200 dark:border-gray-700 rounded-lg">
          <span className="text-[11px] text-slate-500 dark:text-gray-400 font-medium">
            {t('charts.currentGa')}
          </span>
          <input
            type="number"
            min={14}
            max={40}
            value={manualGA !== '' ? manualGA : (contextGA ?? '')}
            onChange={(e) => setManualGA(e.target.value)}
            placeholder="14–40"
            className="w-12 bg-transparent border-none outline-none text-blue-600 dark:text-blue-400 font-bold text-sm text-center"
          />
          <span className="text-[11px] text-slate-400">{t('charts.wks')}</span>
          {contextGA && manualGA === '' && (
            <span className="text-[10px] text-emerald-500 font-medium">
              {t('charts.auto')}
            </span>
          )}
        </div>

        {/* Layout toggle */}
        <div className="flex bg-slate-100 dark:bg-gray-800/50 border border-slate-200 dark:border-gray-700 rounded-lg overflow-hidden">
          {(['grid', 'single'] as const).map((v) => (
            <button
              key={v}
              onClick={() => setLayout(v)}
              className={`px-3 py-1.5 text-xs font-semibold transition-all ${
                layout === v
                  ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
                  : 'text-slate-500 dark:text-gray-400 hover:text-slate-700 dark:hover:text-gray-200'
              }`}
            >
              {v === 'grid' ? t('charts.grid') : t('charts.focus')}
            </button>
          ))}
        </div>

        {/* Measurement legend pill */}
        <div className="flex items-center gap-1.5 px-2.5 py-1 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg">
          <div
            className="w-2.5 h-2.5 rounded-full border-2 border-white dark:border-gray-800"
            style={{ background: '#6366f1', boxShadow: '0 0 0 1px #6366f1' }}
          />
          <span className="text-[11px] font-semibold text-indigo-600 dark:text-indigo-400">
            {t('charts.currentStudyMeasurement')}
          </span>
        </div>
      </div>

      {/* Chart tabs — single mode */}
      {layout === 'single' && (
        <div className="flex gap-1.5 flex-wrap">
          {CHARTS.map((c) => (
            <button
              key={c.id}
              onClick={() => setActiveChart(c.id)}
              className={`px-3 py-1 text-xs font-bold rounded-lg border transition-all ${
                activeChart === c.id
                  ? 'shadow-sm'
                  : 'border-slate-200 dark:border-gray-700 text-slate-500 dark:text-gray-400 hover:text-slate-700 dark:hover:text-gray-200 bg-transparent'
              }`}
              style={
                activeChart === c.id
                  ? {
                      color: c.color,
                      background: `${c.color}18`,
                      borderColor: `${c.color}55`,
                    }
                  : {}
              }
            >
              {c.abbr}
              {measurementValues[c.id] != null && (
                <span className="ml-1 text-indigo-400">●</span>
              )}
            </button>
          ))}
        </div>
      )}

      {/* Charts */}
      {layout === 'grid' ? (
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          {CHARTS.map((c) => (
            <GrowthChart
              key={c.id}
              chart={c}
              currentGA={currentGA}
              measuredValue={measurementValues[c.id]}
            />
          ))}
        </div>
      ) : (
        <div className="max-w-2xl mx-auto">
          {CHARTS.filter((c) => c.id === activeChart).map((c) => (
            <GrowthChart
              key={c.id}
              chart={c}
              currentGA={currentGA}
              measuredValue={measurementValues[c.id]}
            />
          ))}
        </div>
      )}
    </div>
  );
}
